import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class QuantitySpinner extends ThemeComponent {
    @Prop({ default: 1 }) min!: number;
    @Prop({ default: 10 }) max!: number;

    @Ref() input!: HTMLInputElement;
    @Ref() dropdownToggleButton!: HTMLButtonElement;
    @Ref() dropdownOptions!: HTMLElement;
    @Ref() dropdownOption!: HTMLButtonElement[];

    private _onChange = new SimpleEvent<number>();
    get onChange() {
        return this._onChange.asEvent();
    }

    init() {

        // Listen for input value change
        this.listenForInputValueChange();

        // Listen for dropdown toggle button click
        this.listenForDropdownToggleButtonClick();

        // Listen for outer dropdown options click
        this.listenForOuterDropdownOptionsClick();

        // Listen for dropdown option click
        this.listenForDropdownOptionClick();
    }

    listenForInputValueChange() {
        this.$listen(this.input, 'change', () => {
            this.updateInputValue(Number(this.input.value));
        });
    }

    updateInputValue(value: number) {
        this.input.value = (Math.min(this.max, Math.max(this.min, value))).toString();
        this._onChange.dispatch(Number(this.input.value));
    }

    listenForDropdownToggleButtonClick() {
        this.$listen(this.dropdownToggleButton, 'click', () => {
            this.dropdownOptions.classList.toggle('quantity-spinner__dropdown-options--active');
        });
    }

    listenForOuterDropdownOptionsClick() {
        this.$listen(document.body, 'click', (e) => {
            if (!this.dropdownOptions.classList.contains('quantity-spinner__dropdown-options--active')) {
                return;
            }
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                // eslint-disable-next-line max-len
                if (clickedElement !== this.dropdownToggleButton && !this.dropdownToggleButton.contains(clickedElement) && clickedElement !== this.dropdownOptions && !this.dropdownOptions.contains(clickedElement)) {
                    this.dropdownOptions.classList.remove('quantity-spinner__dropdown-options--active');
                }
            }
        });
    }

    listenForDropdownOptionClick() {
        for (const dropdownOption of this.dropdownOption) {
            this.$listen(dropdownOption, 'click', () => {
                const value = dropdownOption.getAttribute('data-value');
                if (value === null) {
                    return;
                }
                this.updateInputValue(Number(value));
            });
        }
    }
}
